import { Component, OnDestroy } from '@angular/core';
import {
    AuthenticationService,
    EspaceClientService,
    EspaceDocumentaireService,
    User,
} from '@kv-common-components/kx-services';
import { take } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { ContextDossier } from '@kv-common-components/kv-common-components';

@Component({
    selector: 'app-consentements-component',
    templateUrl: './consentements.component.html',
    styleUrls: [],
})
export class ConsentementsComponent implements OnDestroy {
    personne: any;
    idPropositionPrincipale: string;
    idDossier: string;
    allDocuments: any[];
    conventionAERAS: any;
    droitOubli: any;
    consentementDoc: any;
    noticeDoc: any;
    contextDossier: any;
    visibility: boolean;
    topSansSelectionMedicale: boolean;
    espaceClientSubscription: Subscription;

    noticeTypologies: string[] = [
        'DOC0001',
        'DOC0003',
        'DOC0004',
        'DOC0005',
        'DOC0006',
        'DOC0007',
    ];

    constructor(
        private authenticationService: AuthenticationService,
        private espaceDocumentaireService: EspaceDocumentaireService,
        private espaceClientService: EspaceClientService
    ) {
        this.visibility = true;
        const currentUser: User = this.authenticationService.currentUserValue;
        this.espaceClientSubscription =
            this.espaceClientService.currentEspaceClient
                .pipe(take(1))
                .subscribe((espaceClient) => {
                    this.idPropositionPrincipale =
                        currentUser.idPropositionPrincipale;
                    this.idDossier = currentUser.idDossier;
                    this.personne = espaceClient.personne;
                    const contextDossier =
                        ContextDossier.initContextDossierFromEspaceClient(
                            currentUser.idPersonne,
                            currentUser.idDossier.toString(),
                            espaceClient
                        );
                    this.topSansSelectionMedicale =
                        contextDossier.emprunteur.topSansSelectionMedicale;
                    this.espaceDocumentaireService
                        .getEspaceDocumentaire(
                            currentUser.idPersonne,
                            currentUser.idPropositionPrincipale
                        )
                        .subscribe((espaceDocumentaire) => {
                            this.allDocuments = espaceDocumentaire;
                            this.setDocs();
                        });
                });
    }

    ngOnDestroy() {
        if (this.espaceClientSubscription) {
            this.espaceClientSubscription.unsubscribe();
        }
    }

    private setDocs() {
        this.conventionAERAS = this.allDocuments.find(
            (doc) => doc.typologie === 'DOC3303'
        );
        this.droitOubli = this.allDocuments.find(
            (doc) => doc.typologie === 'DOC3202'
        );
        this.consentementDoc = this.allDocuments.find(
            (doc) => doc.typologie === 'ADH3025'
        );
        this.noticeDoc = this.allDocuments.find(
            (doc) => doc.typologie === 'DOC3300'
        );
    }
}
